import { render, staticRenderFns } from "./CostForm.vue?vue&type=template&id=4f23d223&scoped=true"
import script from "./CostForm.vue?vue&type=script&lang=js"
export * from "./CostForm.vue?vue&type=script&lang=js"
import style0 from "./CostForm.vue?vue&type=style&index=0&id=4f23d223&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f23d223",
  null
  
)

export default component.exports